import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';

export const selectAuthTokenVerification = (state: RootState) => state.auth.tokenVerification;
export const jwtSelector = (state: RootState) => state.auth.token;
export const selectAuthQueryState = (state: RootState) => state.auth.queryState;
export const selectAuthError = (state: RootState) => state.auth.error;
export const userIDSelector = (state: RootState) => state.auth.userId;
export const accessTypeSelector = (state: RootState) => state.auth.accessType;

// Memoized selector - only recomputes when tokenVerification changes
export const userAdminSelector = createSelector(
  [selectAuthTokenVerification],
  (accountInfo): boolean => {
    if (!accountInfo) return false;
    const assignedGroups = accountInfo?.currentGroups || [];
    const activeGroupID = accountInfo.pvActiveGroupID;
    const assignedGroup = assignedGroups.find((group) => group.i === activeGroupID);
    if (assignedGroup && assignedGroup.a === 1) return true;
    return accountInfo.pvAdministrator === 1;
  }
);
